import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet"

import api from "apis"
import GenericNotFound from "app/generic-not-found"

export default function fetchInstantGift(WrappedComponent) {
  const FetchInstantGift = ({
    giftData,
    lineItemCode,
    skipVideo,
    ...props
  }) => {
    const [data, setData] = useState(giftData)
    const [error, setError] = useState((giftData && giftData.error) || false)
    const cancelled = useRef(false)

    const fetchGift = useCallback(async () => {
      if (!cancelled.current && !giftData && lineItemCode) {
        try {
          let url = `/api/v4/line_items/by_code/${lineItemCode}`
          if (skipVideo) {
            url += "?skip_video=true"
          }
          const result = await api.get(url)
          if (result.error) {
            setError(true)
          } else {
            setData(result)
          }
        } catch (error) {
          console.log(error)
        }
      }
    }, [lineItemCode])

    useEffect(() => {
      fetchGift()
    }, [fetchGift])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    if (error) {
      return <GenericNotFound />
    }

    return (
      <div>
        <Helmet>
          <title>Gift Preview Video</title>
        </Helmet>

        <WrappedComponent data={data} lineItemCode={lineItemCode} {...props} />
      </div>
    )
  }

  FetchInstantGift.propTypes = {
    giftData: PropTypes.object,
    lineItemCode: PropTypes.string,
    skipVideo: PropTypes.bool,
  }

  FetchInstantGift.defaultProps = {
    skipVideo: false,
  }

  return FetchInstantGift
}
